import { useCallback } from 'react';

const EMPTY_ARRAY = [];

export default function useSavedAnswers() {
  const refetch = useCallback(
    () =>
      new Promise((resolve) => {
        setTimeout(() => {
          resolve('foo');
        }, 300);
      }),
    [],
  );

  return {
    data: EMPTY_ARRAY,
    refetch,
  };
}
